"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "NotificationBarReducers", {
  enumerable: true,
  get: function get() {
    return _reducers.NotificationBarReducers;
  }
});
Object.defineProperty(exports, "initialState", {
  enumerable: true,
  get: function get() {
    return _reducers.initialState;
  }
});
Object.defineProperty(exports, "NotificationBarContext", {
  enumerable: true,
  get: function get() {
    return _context.NotificationBarContext;
  }
});
Object.defineProperty(exports, "NotificationBarContainer", {
  enumerable: true,
  get: function get() {
    return _containers["default"];
  }
});
exports.NotificationBarWrapperWithContext = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reducers = require("./reducers");

var _context = require("./context");

var _containers = _interopRequireDefault(require("./containers"));

// A HOC to wrap components into NotificationBarContext Provider
var NotificationBarWrapperWithContext = function NotificationBarWrapperWithContext(_ref) {
  var children = _ref.children;

  var _useReducer = (0, _react.useReducer)(_reducers.NotificationBarReducers, _reducers.initialState),
      _useReducer2 = (0, _slicedToArray2["default"])(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  return _react["default"].createElement(_context.NotificationBarContext.Provider, {
    value: {
      state: state,
      dispatch: dispatch
    }
  }, children);
};

exports.NotificationBarWrapperWithContext = NotificationBarWrapperWithContext;
NotificationBarWrapperWithContext.propTypes = {
  children: _propTypes["default"].node
};